import type { LabelRecordMap } from '@libs/data-access/entities'
import type { ReduxState } from '@spa/redux/ReduxState'

import {
  getDataByForeignId,
  getDataByForeignIds
} from '../../services/immutableUtils'

export const getLabelById = (state: ReduxState, id: number) => {
  const noLabel = { id: '', name: 'Aucune étiquette', color: '#f8f9fb' }
  return state.labels.getIn(['data', id]) || noLabel
}

export const getLabelsByTeamId = (
  state: ReduxState,
  teamId: number
): LabelRecordMap => getDataByForeignId(state, 'labels', 'team_id', teamId)

export const getLabelsByTeamIds = (
  state: ReduxState,
  teamIds: number[]
): LabelRecordMap => getDataByForeignIds(state, 'labels', 'team_id', teamIds)
